import { useTranslation } from 'react-i18next';
import Topbar from '../../../Component/common/Topbar/Topbar';
import Navbar from '../../../Component/common/Navbar/Navbar';
import LandPage from '../../../Component/common/LandPage/LandPage';
import DoctorsSection from '../../../Component/sections/DoctorsSection/DoctorsSection';
import Footer from '../../../Component/common/Footer/Footer';
import './Doctors.css';

function Doctors() {
	const { t } = useTranslation();

	return (
		<>
			<div className='doctors-page'>
				<Topbar />
				<Navbar />
				<LandPage header={t('doctors')} link={t('doctors')} href='/doctors' />
				<DoctorsSection />
				<Footer />
			</div>
		</>
	);
}

export default Doctors;